import { PATH_DEFAULT_STORE_PROJECT_ASSIGNEES, PATH_ROOT } from "@/constants";
import { BreadcrumbItem } from "@/types/breadcrumb";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

export const useDefaultStoreProjectAssigneeBreadcrumbs = (
  additionalItems?: (BreadcrumbItem | undefined)[],
) => {
  const { t } = useTranslation();

  return useMemo(() => {
    const breadcrumbItems: BreadcrumbItem[] = [
      { label: t("breadcrumb.home"), href: PATH_ROOT },
      {
        label: t("defaultStoreProjectAssignees.breadcrumb.directory"),
        href: PATH_DEFAULT_STORE_PROJECT_ASSIGNEES,
      },
    ];

    if (additionalItems && additionalItems.length > 0) {
      breadcrumbItems.push(...additionalItems.filter((item) => !!item));
    }

    return breadcrumbItems;
  }, [t, additionalItems]);
};
